import { render, staticRenderFns } from "./edit-extra.vue?vue&type=template&id=28ef15f2&scoped=true&"
import script from "./edit-extra.vue?vue&type=script&lang=js&"
export * from "./edit-extra.vue?vue&type=script&lang=js&"
import style0 from "./edit-extra.vue?vue&type=style&index=0&id=28ef15f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ef15f2",
  null
  
)

export default component.exports